export default __webpack_public_path__ + "static/media/triangle-atention.48a4c8b8.svg";